require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-why-libsass-is-important-to-the-community.json") })
        }
      }, "path---blog-why-libsass-is-important-to-the-community");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-why-libsass-is-important-to-the-community!./.cache/json/blog-why-libsass-is-important-to-the-community.json
// module id = 1172
// module chunks = 231608221292675